import React from 'react';
import EmailVerificationBanner from '../../website/components/common/EmailVerificationBanner';
import { useAppEmailVerificationBanner } from './useAppEmailVerificationBanner';

const AppEmailVerificationBanner = () => {
  const showBanner = useAppEmailVerificationBanner();

  if (!showBanner) {
    return null;
  }

  return <EmailVerificationBanner variant="app" />;
};

export default AppEmailVerificationBanner;
